// extracted by mini-css-extract-plugin
export var DropdownMenuContent = "dropdown-styles-module--DropdownMenuContent--40eb8";
export var DropdownMenuItem = "dropdown-styles-module--DropdownMenuItem--2e5ae";
export var IconButtonDd = "dropdown-styles-module--IconButtonDd--ab1b8";
export var dropdownPortal = "dropdown-styles-module--dropdownPortal--94089";
export var slideDownAndFade = "dropdown-styles-module--slideDownAndFade--cbe0e";
export var slideLeftAndFade = "dropdown-styles-module--slideLeftAndFade--22a8c";
export var slideRightAndFade = "dropdown-styles-module--slideRightAndFade--f5aa9";
export var slideUpAndFade = "dropdown-styles-module--slideUpAndFade--a068e";